import { sendCtmEvtLog } from '@/utils/log'

export default function (page_name) {
    return {
        methods: {
            $clickLog (name, data = {}) {
                sendCtmEvtLog(`${page_name}-${name}点击`, data)
            }
        }
    }
}
